import SEOHead from '@/components/SEOHead';
import { Typography } from 'antd';
import Image from 'next/image';
import Link from 'next/link';

const { Title, Paragraph, Text } = Typography;

const RefundPolicy = () => {
  return (
    <div>
      <SEOHead />
      <div role="banner" className="header-small-wrapper w-nav">
        <div className="container-default w-container">
          <div className="header-small-content-wrapper">
            <Link href="/" className="header-small-logo-link w-nav-brand">
              <Image
                src="/images/logo.svg"
                alt="Logo - Brandymail.com"
                className="header-logo"
                height={50}
                width={150}
                priority
              />
            </Link>
          </div>
        </div>
      </div>
      <div className="section utility-page policy-page">
        <div className="container-default width-100 w-container">
          <div className="position-relative z-index-1">
            <div className="inner-container _765px center">
              <div className="inner-container _600px---mbl center">
                <div className="mg-bottom-45px">
                  <div className="inner-container _765px center">
                    <div className="text-center">
                      <h1 className="display-1 color-neutral-100 mg-bottom-16px">Refund Policy</h1>
                    </div>
                  </div>
                </div>
                <div className="card log-in-form-block w-form text-200 color-neutral-800">
                  <p>
                    <strong>Last Updated: 12-15-25</strong>
                  </p>
                  <p>
                    Brandymail (&quot;<strong>Brandymail</strong>,&quot; &quot;<strong>we</strong>
                    ,&quot; &quot;
                    <strong>us</strong>,&quot; or &quot;<strong>our</strong>&quot;) is operated by{' '}
                    <strong>Valiweb Services, LLC</strong>. This Refund Policy explains our refund
                    practices for subscriptions and certificate-related products. For questions,
                    contact{' '}
                    <a href="mailto:support@brandymail.com">
                      <strong>support@brandymail.com</strong>
                    </a>
                    .
                  </p>
                  <hr
                    style={{ margin: '20px 0', border: 'none', borderTop: '1px solid #e0e0e0' }}
                  />
                  <p>
                    <strong>1) Our Commitment</strong>
                  </p>
                  <p>
                    We stand behind our services and are committed to customer satisfaction. This
                    policy outlines when refunds are available and how to request them.
                  </p>
                  <hr
                    style={{ margin: '20px 0', border: 'none', borderTop: '1px solid #e0e0e0' }}
                  />
                  <p>
                    <strong>2) Subscription Services Refunds</strong>
                  </p>
                  <p>
                    <strong>30-Day Money-Back Guarantee</strong>
                  </p>
                  <p>
                    We offer a 30-day money-back guarantee on subscription services. If you are not
                    satisfied with your subscription, you may request a refund within 30 days from
                    the original purchase date.
                  </p>
                  <p>
                    <strong>Important:</strong> Subscription billing begins on the purchase date (as
                    stated in our Terms &amp; Conditions), and refunds are calculated from that
                    date. Refunds for subscriptions are typically prorated based on unused time
                    remaining in the billing period.
                  </p>
                  <p>
                    <strong>Eligibility Requirements:</strong>
                  </p>
                  <ul>
                    <li>The request must be made within 30 days of the original purchase date</li>
                    <li>Your account must be in good standing</li>
                    <li>You must provide a reason for the refund request</li>
                  </ul>
                  <hr
                    style={{ margin: '20px 0', border: 'none', borderTop: '1px solid #e0e0e0' }}
                  />
                  <p>
                    <strong>3) Certificate-Related Products</strong>
                  </p>
                  <p>
                    <strong>Non-Refundable After Processing Begins</strong>
                  </p>
                  <p>
                    Certificate-related fees (including Verified Mark Certificates (VMC), Common
                    Mark Certificates (CMC), and related products) may be{' '}
                    <strong>non-refundable</strong> once:
                  </p>
                  <ul>
                    <li>Third-party certificate provider processing begins</li>
                    <li>Validation workflows are initiated</li>
                    <li>
                      Pass-through costs to certificate providers (e.g., DigiCert) are incurred
                    </li>
                  </ul>
                  <p>
                    This is because certificate issuance involves third-party validation, approval
                    processes, and costs that cannot be recovered once initiated. If you cancel
                    before processing begins, you may be eligible for a refund or account credit at
                    our discretion.
                  </p>
                  <hr
                    style={{ margin: '20px 0', border: 'none', borderTop: '1px solid #e0e0e0' }}
                  />
                  <p>
                    <strong>4) Account Credit Option</strong>
                  </p>
                  <p>
                    As an alternative to a refund, you may choose to receive account credit equal to
                    the eligible refund amount. Account credit:
                  </p>
                  <ul>
                    <li>Can be applied to any Brandymail services</li>
                    <li>Remains valid for 12 months from the date of issue</li>
                    <li>Is non-transferable and non-refundable</li>
                  </ul>
                  <p>
                    This option may be particularly beneficial if you plan to use our services in
                    the future or wish to try a different service level.
                  </p>
                  <hr
                    style={{ margin: '20px 0', border: 'none', borderTop: '1px solid #e0e0e0' }}
                  />
                  <p>
                    <strong>5) How to Request a Refund</strong>
                  </p>
                  <p>To initiate a refund request:</p>
                  <ul>
                    <li>
                      Contact our support team at{' '}
                      <a href="mailto:support@brandymail.com">support@brandymail.com</a>
                    </li>
                    <li>Include your order number or account information</li>
                    <li>Provide the reason for your refund request</li>
                    <li>Specify whether you prefer a refund or account credit</li>
                  </ul>
                  <p>
                    We will review your request and respond within 2-3 business days. We may ask for
                    additional information to process your request.
                  </p>
                  <hr
                    style={{ margin: '20px 0', border: 'none', borderTop: '1px solid #e0e0e0' }}
                  />
                  <p>
                    <strong>6) Processing Time</strong>
                  </p>
                  <p>
                    Once approved, refunds are typically processed within 5-7 business days. The
                    time it takes for the refund to appear in your account may vary depending on:
                  </p>
                  <ul>
                    <li>Your payment method (credit card, bank transfer, etc.)</li>
                    <li>Your financial institution&apos;s processing time</li>
                    <li>Payment processor policies</li>
                  </ul>
                  <p>
                    Refunds are issued to the original payment method used for the purchase when
                    possible.
                  </p>
                  <hr
                    style={{ margin: '20px 0', border: 'none', borderTop: '1px solid #e0e0e0' }}
                  />
                  <p>
                    <strong>7) Exceptions and Limitations</strong>
                  </p>
                  <p>
                    While we strive to accommodate reasonable refund requests, certain circumstances
                    may affect eligibility:
                  </p>
                  <ul>
                    <li>
                      <strong>Requests after the 30-day period:</strong> Refund requests made after
                      30 days from purchase are generally not eligible
                    </li>
                    <li>
                      <strong>Service misuse or abuse:</strong> Accounts with evidence of service
                      misuse, fraud, or policy violations may not be eligible
                    </li>
                    <li>
                      <strong>Third-party costs:</strong> Fees passed through to certificate
                      providers or other third parties may not be refundable once incurred
                    </li>
                    <li>
                      <strong>Billing errors:</strong> If you believe there was a billing error,
                      contact support promptly for resolution
                    </li>
                  </ul>
                  <hr
                    style={{ margin: '20px 0', border: 'none', borderTop: '1px solid #e0e0e0' }}
                  />
                  <p>
                    <strong>8) Subscription Cancellations</strong>
                  </p>
                  <p>
                    Subscription cancellations take effect at the end of the then-current billing
                    term (unless otherwise specified). Canceling a subscription does not
                    automatically entitle you to a refund for the current billing period. Refunds
                    for canceled subscriptions are subject to the 30-day money-back guarantee terms
                    above.
                  </p>
                  <p>
                    To cancel a subscription, contact support or use your account settings (where
                    available).
                  </p>
                  <hr
                    style={{ margin: '20px 0', border: 'none', borderTop: '1px solid #e0e0e0' }}
                  />
                  <p>
                    <strong>9) Contact Us</strong>
                  </p>
                  <p>
                    If you have questions about this Refund Policy or need assistance with a refund
                    request, please contact our customer support team at{' '}
                    <a href="mailto:support@brandymail.com">
                      <strong>support@brandymail.com</strong>
                    </a>
                    .
                  </p>
                  <hr
                    style={{ margin: '20px 0', border: 'none', borderTop: '1px solid #e0e0e0' }}
                  />
                  <p>
                    <strong>10) Policy Updates</strong>
                  </p>
                  <p>
                    We reserve the right to modify this Refund Policy at any time. Material changes
                    will be posted on this page with an updated revision date. Your continued use of
                    our services after such modifications constitutes acceptance of the updated
                    policy.
                  </p>
                  <hr
                    style={{ margin: '20px 0', border: 'none', borderTop: '1px solid #e0e0e0' }}
                  />
                  <p>
                    <strong>11) Legal Disclaimer</strong>
                  </p>
                  <p>
                    This Refund Policy is provided for informational purposes and should be reviewed
                    alongside our Terms &amp; Conditions. It is advised to consult with legal
                    counsel to ensure compliance with applicable laws and your specific business
                    practices.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="position-absolute dark-fade---button utility-page-fade"></div>
      </div>
    </div>
  );
};

export default RefundPolicy;
